import { useState, useEffect } from "react";
import { Pencil, Plus, LocateFixed, Check, X, MapPin, Camera } from "lucide-react";
import axios from "axios";
import { toast, Toaster } from "sonner";
import { Autocomplete } from "@react-google-maps/api";

export default function UserProfile() {
  const GOOGLE_MAPS_API_KEY = "AIzaSyAHFoepvVjrlMUctcC4wn_VRpOznZBzmhA";
  const [addresses, setAddresses] = useState([]);
  const [newAddress, setNewAddress] = useState({
    address: "",
    landmark: "",
    addressType: "",
    lat: "",
    lng: ""
  });
  const [user, setUser] = useState({});
  const [profile, setProfile] = useState({ name: "", email: "" });
  const [image, setImage] = useState(null);
  const [updateFile, updateSetFile] = useState(null);
  const [editingAddress, setEditingAddress] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);
  const [editForm, setEditForm] = useState({
    address: "",
    landmark: "",
    addressType: "",
  });
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);
  const token = localStorage.getItem("token");
  console.log("addresses : " , addresses)

  const fetchUserData = async () => {
    try {
      const res = await axios.get("https://wavetechservices.in/api/user/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data.user);
      setProfile({ name: res.data.user.name, email: res.data.user.email });
      updateSetFile(res.data.user.profilePicture);
      setAddresses(res.data.user.addresses);
    } catch (err) {
      console.error("Error fetching user data:", err);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  // const handleImageChange = (e) => {
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => setImage(reader.result);
  //     reader.readAsDataURL(selectedFile);
  //     updateSetFile(selectedFile);
  //   }
  // };

  // Updated handleImageChange function
  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Only create object URL if it's a File object
      if (selectedFile instanceof File) {
        const reader = new FileReader();
        reader.onloadend = () => setImage(reader.result);
        reader.readAsDataURL(selectedFile);
      }
      updateSetFile(selectedFile);
    }
  };

  const updateProfile = async () => {
    if (!token) {
      toast.error("Please Login");
      return;
    }
    
    const formData = new FormData();
    if (updateFile) formData.append("profilePicture", updateFile);
    profile.name && formData.append("name", profile.name);
    profile.email && formData.append("email", profile.email);

    try {
      await axios.put("https://wavetechservices.in/api/user/profile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      fetchUserData();
      toast.success("Profile updated successfully");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error updating profile");
      console.error("Error updating Profile:", err);
    }
  };

  const handleLocationSelect = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();
    if (!place.geometry) {
      toast.error("Please select a valid location from the dropdown");
      return;
    }

    const address = place.formatted_address;
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    setSelectedLocation({
      label: address,
      value: place
    });

    setNewAddress(prev => ({
      ...prev,
      address: address,
      lat: lat,
      lng: lng
    }));
  };

  const handleCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();
          
          if (data.results && data.results[0]) {
            const address = data.results[0].formatted_address;
            
            setSelectedLocation({
              label: address,
              value: { geometry: { location: { lat: () => lat, lng: () => lng } } }
            });

            setNewAddress({
              address: address,
              landmark: "",
              addressType: "Current Location",
              lat: lat,
              lng: lng
            });
          }
        } catch (error) {
          console.error("Geocoding error:", error);
          toast.error("Failed to get address from coordinates");
        }
      },
      (error) => {
        console.error("Geolocation error:", error);
        toast.error("Failed to get current location");
      }
    );
  };

  const addAddress = async () => {
    if (!token) {
      toast.error("Please login to add address");
      return;
    }

    if (!newAddress.address || !newAddress.addressType) {
      toast.error("Address and address type are required");
      return;
    }

    if (!newAddress.lat || !newAddress.lng) {
      toast.error("Please select a valid location");
      return;
    }

    try {
      const res = await axios.post(
        "https://wavetechservices.in/api/user/address",
        newAddress,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setAddresses(res.data.adress);
      setNewAddress({ address: "", landmark: "", addressType: "", lat: "", lng: "" });
      setSelectedLocation(null);
      fetchUserData();
      toast.success("Address added successfully");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error adding address");
      console.error("Error adding address:", err);
    }
  };

  const startEditing = (address) => {
    setEditingAddress(address._id);
    setEditForm({
      address: address.address,
      landmark: address.landmark,
      addressType: address.addressType,
    });
  };

  const cancelEditing = () => {
    setEditingAddress(null);
  };

  const updateAddress = async (addressId) => {
    try {
      await axios.put(
        `https://wavetechservices.in/api/user/address/${addressId}`,
        editForm,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchUserData();
      setEditingAddress(null);
      toast.success("Address updated successfully");
    } catch (err) {
      toast.error(err.response?.data?.message || "Error updating address");
      console.error("Error updating address:", err);
    }
  };

  const deleteAddress = async (addressId) => {
    if (!window.confirm("Are you sure you want to delete this address?")) return;

    try {
      await axios.delete(
        `https://wavetechservices.in/api/user/address/${addressId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchUserData();
      toast.success("Address deleted successfully");
    } catch (err) {
      toast.error("Error deleting address");
      console.error("Error deleting address:", err);
    }
  };

  console.log("user : " , user)
  
  return (
    <div className="max-w-4xl mx-auto my-24 p-6 space-y-6">
      <Toaster />
      
      {/* Profile Section */}
      <div className="p-6 shadow-lg rounded-2xl bg-white">
        <h2 className="text-2xl font-bold">Profile Details</h2>
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mt-4 space-y-4 w-full md:w-1/2">
            <input
              type="text"
              value={profile.name}
              placeholder="Name"
              onChange={(e) => setProfile({ ...profile, name: e.target.value })}
              className="p-2 border rounded-md w-full"
            />
            <input
              type="text"
              placeholder="Email"
              value={profile.email}
              onChange={(e) => setProfile({ ...profile, email: e.target.value })}
              className="p-2 border rounded-md w-full"
            />
            <div>
              <p><span className="font-bold">Mobile:</span> {user.phone}</p>
            </div>
            <button
              onClick={updateProfile}
              className="gradient text-white px-4 py-2 rounded"
            >
              Save Profile
            </button>
          </div>
          
          <div className="flex flex-col items-center justify-center">
  <div className="relative group">
    <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-full overflow-hidden border-2 border-gray-300 shadow-lg bg-gray-100 flex items-center justify-center">
      {updateFile ? (
        typeof updateFile === 'string' ? (
          <img
            src={`${updateFile}`}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        ) : (
          <img
            src={URL.createObjectURL(updateFile)}
            alt="Profile"
            className="w-full h-full object-cover"
          />
        )
      ) : user?.profilePicture ? (
        <img
          src={`${user.profilePicture}`}
          alt="Profile"
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="text-gray-500 text-sm">No Photo</div>
      )}
    </div>
    <label className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
      <Camera className="text-white w-8 h-8" />
      <input
        type="file"
        className="hidden"
        accept="image/*"
        onChange={handleImageChange}
      />
    </label>
  </div>
</div>
        </div>
      </div>

      {/* Address Section */}
      <div className="p-6 shadow-lg rounded-2xl bg-white">
        <h2 className="text-2xl font-bold">Addresses</h2>
        
        <div className="mt-5">
          <Autocomplete 
            onLoad={setAutocomplete}
            onPlaceChanged={handleLocationSelect}
            fields={['formatted_address', 'geometry']}
          >
            <input 
              type="text" 
              placeholder="Search for your location" 
              className="w-full p-2 border rounded-md" 
              value={newAddress.address}
              onChange={(e) => setNewAddress({...newAddress, address: e.target.value})}
            />
          </Autocomplete>
          
          <div className="flex justify-between gap-3 w-full flex-col md:flex-row items-center mt-4">
            <div 
              className="flex gap-3 items-center w-full font-bold hover:underline cursor-pointer"
              onClick={handleCurrentLocation}
            >
              <LocateFixed />
              Use Current Location
            </div>
            
            <div className="flex gap-3 w-full flex-col md:flex-row">
              <select
                value={newAddress.addressType}
                onChange={(e) => setNewAddress({...newAddress, addressType: e.target.value})}
                className="p-2 w-full border rounded-md"
              >
                <option value="">Select Address Type</option>
                <option value="Home">Home</option>
                <option value="Work">Work</option>
                <option value="Other">Other</option>
              </select>
              
              <button
                onClick={addAddress}
                className="gradient w-full text-white px-4 py-2 rounded flex items-center gap-2"
              >
                <Plus className="w-4 h-4" /> Add Address
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-4">
          {user?.addresses?.map((addr) => (
            <div key={addr._id} className="p-4 border rounded-md">
              {editingAddress === addr._id ? (
                <div className="space-y-2">
                  <input
                    type="text"
                    value={editForm.address}
                    onChange={(e) => setEditForm({...editForm, address: e.target.value})}
                    className="p-2 border rounded-md w-full"
                    placeholder="Address"
                  />
                  <input
                    type="text"
                    value={editForm.landmark}
                    onChange={(e) => setEditForm({...editForm, landmark: e.target.value})}
                    className="p-2 border rounded-md w-full"
                    placeholder="Landmark"
                  />
                  <select
                    value={editForm.addressType}
                    onChange={(e) => setEditForm({...editForm, addressType: e.target.value})}
                    className="p-2 border rounded-md w-full"
                  >
                    <option value="Home">Home</option>
                    <option value="Work">Work</option>
                    <option value="Other">Other</option>
                  </select>
                  <div className="flex gap-2 mt-2">
                    <button
                      onClick={() => updateAddress(addr._id)}
                      className="bg-green-500 text-white px-4 py-2 rounded-md flex items-center gap-2"
                    >
                      <Check className="w-4 h-4" /> Save
                    </button>
                    <button
                      onClick={cancelEditing}
                      className="bg-gray-500 text-white px-4 py-2 rounded-md flex items-center gap-2"
                    >
                      <X className="w-4 h-4" /> Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold">{addr.addressType}</p>
                    <p>{addr.address}</p>
                    {addr.landmark && <p className="text-sm text-gray-600">Landmark: {addr.landmark}</p>}
                    {/* <p className="text-xs text-gray-500 mt-1">
                      Coordinates: {addr.lat?.toFixed(6)}, {addr.lng?.toFixed(6)}
                    </p> */}
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => startEditing(addr)}
                      className="text-blue-500 hover:text-blue-700"
                    >
                      <Pencil className="w-5 h-5" />
                    </button>
                    <button
                      onClick={() => deleteAddress(addr._id)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}